module.exports = __webpack_public_path__ + "img/22.246d1d49.png";